import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";
import ExaminerSelector from "./ExaminerSelector";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function NewExamProcess(props) {
  const [saveDisabled, setSaveDisabled] = React.useState(true);
  const [errors, setErrors] = React.useState({
    examProcessExistsError: "",
  });

  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [amountOfPharms, setAmountOfPharms] = React.useState(25);
  const [selectedExaminers, setSelectedExaminers] = React.useState([]);

  const clearForm = () => {
    setStartDate("");
    setEndDate("");
    setAmountOfPharms(25);
    setSelectedExaminers([]);
  };

  useEffect(() => {
    if (
      !(
        startDate === "" ||
        endDate === "" ||
        amountOfPharms <= 0 ||
        selectedExaminers.length === 0
      )
    ) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [startDate, endDate, amountOfPharms, selectedExaminers]);

  const handleSubmitNewUser = (e) => {
    const formData = {
      startingDate: startDate,
      closingDate: endDate,
      amountOfPharms,
      examiners: selectedExaminers,
    };

    e.preventDefault();
    setSaveDisabled(true);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examProcess/add",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unable to access endpoint: examProcess/add");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.id < 0) {
          setErrors({ examProcessExistsError: "examProcessExistsError" });
        } else {
          clearForm();
          props.setRows((prev) =>
            prev.concat([
              {
                id: data.id,
                startingDateString: data.startingDateString,
                closingDateString: data.closingDateString,
                amountOfPharms: amountOfPharms,
                examiners: selectedExaminers,
                results: data.results,
                pharmacies: data.pharmacies,
              },
            ])
          );
        }
        setGlobalMessage({
          globalMessage: "Prüfung angelegt",
          severity: "success",
        });
      })
      .catch((error) => {
        if (error.name === "TypeError" || error.name === "SyntaxError") {
          setGlobalMessage({
            globalMessage: "Fehler: Kein aktives Szenario",
            severity: "error",
          });
        } else {
          setGlobalMessage({ globalMessage: error.name, severity: "error" });
        }
      })
      .finally(() => setSaveDisabled(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <Box component="form" onSubmit={(e) => handleSubmitNewUser(e)}>
        <DialogTitle>Neue Prüfung erstellen</DialogTitle>
        <DialogContent>
          <div>
            <TextField
              id="startDate"
              label="Startdatum"
              type="date"
              defaultValue={new Date().toLocaleDateString()}
              value={startDate}
              sx={{ width: 220, mr: 5, mt: 2 }}
              InputLabelProps={{
                shrink: true,
              }}
              onInput={(e) => {
                setStartDate(e.target.value);
              }}
            />

            <TextField
              id="endDate"
              label="Geplantes Enddatum"
              type="date"
              value={endDate}
              defaultValue={new Date().toLocaleDateString()}
              sx={{ width: 220, mt: 2 }}
              InputLabelProps={{
                shrink: true,
              }}
              onInput={(e) => {
                setEndDate(e.target.value);
              }}
            />
          </div>

          <div>
            <TextField
              id="amountOfPharms"
              label="Anzahl der zu prüfenden Apotheken"
              type="number"
              value={amountOfPharms}
              sx={{ mt: 3, width: "100%", mb: 3 }}
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
              onInput={(e) => {
                e.target.value >= 1
                  ? setAmountOfPharms(e.target.value)
                  : setAmountOfPharms(1);
              }}
            />
          </div>

          <div>
            <ExaminerSelector
              width="100%"
              selectedExaminers={selectedExaminers}
              setSelectedExaminers={setSelectedExaminers}
            />
          </div>

          {errors.examProcessExistsError && (
            <Alert sx={{ mt: 3 }} variant="outlined" severity="error">
              <ul style={{ margin: 0 }}>
                {errors.examProcessExistsError && (
                  <li key="examProcessExistsError">
                    {errors.examProcessExistsError}
                  </li>
                )}
              </ul>
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)}>Schließen</Button>
          <Button onClick={() => clearForm()}>Formular leeren</Button>
          <Button type="submit" disabled={saveDisabled}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
